import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { VehicleImportModel } from 'src/app/models/imports/vehicle-import-model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { VehicleService } from 'src/app/services/archive/vehicle.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-vehicle',
  templateUrl: './import-vehicle.component.html',
  styleUrls: ['./import-vehicle.component.scss'],
  standalone: false
})
export class ImportVehicleComponent {

  errorVehicle: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;
  vehicleAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  vehicleImport: boolean = false;

  constructor(
    private vehicleService: VehicleService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.vehicleImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadGuideImport() {
    this.vehicleService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaVehiculos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.vehicleAlerts || this.vehicleAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.vehicleService.exportImportErrors(this.vehicleAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionVehiculos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importVehicles() {
    this.vehicleAlerts = [];
    this.errorVehicle = 0;
    this.visibleTxt = false;
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (!isPlatformBrowser(this.platformId)) return;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<VehicleImportModel>();
    let row: VehicleImportModel;
    let counter: number = 1, branchCode: number, description: string, typeCode: number, plate: string, capacity: number,
      storeCode: number, cityCode: string, departmentCode: string, active: boolean, swExternal: boolean;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }
      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Código Sucursal:
        branchCode = parseFloat(element[0] as string);
        if (isNaN(branchCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El código de la sucursal no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //B. Descripción:
        description = element[1] as string;
        if (description == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. La descripción del vehículo no es válida.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        } else if (description.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. La descripción del vehículo supera el tamaño máximo de caracteres (50).`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //C. Tipo Vehículo:
        const valueTypeCode = element[2];
        if (valueTypeCode == null || valueTypeCode === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código del tipo de vehículo no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }
        typeCode = Number(valueTypeCode);
        if (isNaN(typeCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código del tipo de vehículo no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //D. Placa:
        plate = element[3] as string;
        if (plate == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. La placa del vehículo no es válida.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        } else if (plate.length > 8) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. La placa del vehículo supera el tamaño máximo de caracteres (8).`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //E. Capacidad:
        const valueCapacity = element[4];
        if (valueCapacity == null || valueCapacity === "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. La capacidad del vehículo no es válida.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }
        capacity = Number(valueCapacity);
        if (isNaN(capacity)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. La capacidad del vehículo no es válida.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        // Código Bodega
        const valueStoreCode = element[5];
        storeCode = Number(valueStoreCode);
        if (isNaN(storeCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código de la bodega no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //G. Ciudad:
        cityCode = element[6] as string;
        if (cityCode == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El código de la ciudad no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        } else if (cityCode.length > 30) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El código de la ciudad supera el tamaño máximo de caracteres (30).`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        //H. Departamento:
        departmentCode = element[7] as string;
        if (departmentCode == null || departmentCode == "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El código del departamento no es válido.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        } else if (departmentCode.length > 30) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. El código del departamento supera el tamaño máximo de caracteres (30).`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }

        // I. Activo:
        if (element[8] as string != "S" && element[8] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo Activo debe tener valores como: S / N.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }
        active = element[8] as string === "S" ? true : false

        // J. Sw Externo:
        if (element[9] as string != "S" && element[9] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. El campo Sw Externo debe tener valores como: S / N.`;
          this.vehicleAlerts.push(alert);
          rowHasError = true;
        }
        swExternal = element[9] as string === "S" ? true : false

        if (!rowHasError) {
          row = new VehicleImportModel(counter, branchCode, description, typeCode, plate, capacity, storeCode, cityCode,
            departmentCode, active, swExternal);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorVehicle = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        return;
      }

      await this.processImportVehicles(rowsImports);
    });
  }

  async processImportVehicles(rowsImports: Array<VehicleImportModel>) {
    try {
      const response = await firstValueFrom(this.vehicleService.importVehicles(rowsImports));
      this.loadPreInvoicingModel = response;
      this.vehicleAlerts = response?.alerts ?? [];
      this.errorVehicle = response?.preInvoicingStateId;

      if (this.errorVehicle === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.vehicleAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.vehicleImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Vehículos.', error);
    }
  }
}
